import { useEffect, useState } from "react";
import { useTelegram } from "./hooks/useTelegram";
import { api, setToken, getToken } from "./lib/api";
import { BottomNav } from "./components/BottomNav";
import { Inbox } from "./pages/Inbox";
import { SearchPage } from "./pages/Search";
import { ProjectsPage } from "./pages/Projects";
import { ProfilePage } from "./pages/Profile";
import { Loader2 } from "lucide-react";

type Tab = "inbox" | "projects" | "search" | "graph" | "profile";

export default function App() {
  const { initData } = useTelegram();
  const [ready, setReady] = useState(false);
  const [authError, setAuthError] = useState("");
  const [tab, setTab] = useState<Tab>("inbox");

  useEffect(() => {
    async function auth() {
      if (getToken()) {
        setReady(true);
        return;
      }

      if (!initData) {
        console.warn("No Telegram initData — running in dev mode");
        setReady(true);
        return;
      }

      try {
        const res = await api.auth(initData);
        setToken(res.token);
        setReady(true);
      } catch (e: any) {
        setAuthError(e.message || "Auth failed");
      }
    }
    auth();
  }, [initData]);

  if (authError) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 text-center">
        <div>
          <p className="text-red-400 mb-2">Ошибка авторизации</p>
          <p className="text-sm text-white/50">{authError}</p>
        </div>
      </div>
    );
  }

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="animate-spin text-accent" size={32} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-surface text-white">
      {tab === "inbox" && <Inbox />}
      {tab === "search" && <SearchPage />}
      {tab === "projects" && <ProjectsPage />}
      {tab === "graph" && (
        <div className="p-6 text-center pt-20">
          <p className="text-white/40 mb-2">Граф связей</p>
          <p className="text-sm text-white/25">
            Связи строятся автоматически при создании заметок.
            Визуализация появится в следующем обновлении.
          </p>
        </div>
      )}
      {tab === "profile" && <ProfilePage />}

      <BottomNav active={tab} onChange={setTab} />
    </div>
  );
}
